import { render, staticRenderFns } from "./returnVisit.vue?vue&type=template&id=61663001&scoped=true&"
import script from "./returnVisit.vue?vue&type=script&lang=js&"
export * from "./returnVisit.vue?vue&type=script&lang=js&"
import style0 from "./returnVisit.vue?vue&type=style&index=0&id=61663001&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61663001",
  null
  
)

export default component.exports